import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { ThemeProvider } from './contexts/ThemeContext';
import { MarketingLayout } from './components/layouts/MarketingLayout';
import { FloatingJaneChat } from './components/FloatingJaneChat';
import { SHOW_PRODUCTS, MAINTENANCE_MODE } from './config/site';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import InvestPage from './pages/InvestPage';
import ProductsPage from './pages/ProductsPage';
import MaintenancePage from './pages/MaintenancePage';

function MarketingRoute({ children }) {
  return <MarketingLayout>{children}</MarketingLayout>;
}

function AppRoutes() {
  if (MAINTENANCE_MODE) {
    return (
      <Routes>
        <Route path="/" element={<MaintenancePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <MarketingRoute>
            <HomePage />
          </MarketingRoute>
        }
      />
      <Route
        path="/about"
        element={
          <MarketingRoute>
            <AboutPage />
          </MarketingRoute>
        }
      />
      <Route path="/contact" element={<ContactPage />} />
      <Route
        path="/services"
        element={
          <MarketingRoute>
            <ServicesPage />
          </MarketingRoute>
        }
      />
      <Route
        path="/invest"
        element={
          <MarketingRoute>
            <InvestPage />
          </MarketingRoute>
        }
      />
      <Route
        path="/products"
        element={
          SHOW_PRODUCTS ? (
            <MarketingRoute>
              <ProductsPage />
            </MarketingRoute>
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <AppRoutes />
          {!MAINTENANCE_MODE && <FloatingJaneChat />}
          <Toaster
            position="top-right"
            richColors
            closeButton
            toastOptions={{
              className: 'font-body',
            }}
          />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
